var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 491,
    viewBox: "0 0 414 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.493 6.67894V73.1589V418.467V483.818H327.759L316.524 473.982L314.63 472.324H312.109H101.077H98.5581L96.6641 473.982L85.4294 483.818H6.69489V418.467V73.1589V6.67894H85.4294L96.6641 16.5148L98.5581 18.1734H101.077H312.109H314.63L316.524 16.5148L327.759 6.67894H406.493ZM413.186 0H325.238L312.109 11.4945H101.077L87.9481 0H0V73.1589V418.467V490.497H87.9481L101.077 479.003H312.109L325.238 490.497H413.186V418.467V73.1589V0Z",
    fill: "#E89005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.475 319.4V170.606L390.375 188.938V301.07L406.475 319.4Z",
    fill: "url(#paint0_linear_1_119)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 290.933H401.205V286.54H396.811V290.933Z",
    fill: "url(#paint1_linear_1_119)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 279.999H401.205V275.606H396.811V279.999Z",
    fill: "url(#paint2_linear_1_119)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 269.066H401.205V264.673H396.811V269.066Z",
    fill: "url(#paint3_linear_1_119)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 258.132H401.205V253.741H396.811V258.132Z",
    fill: "url(#paint4_linear_1_119)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 247.2H401.205V242.808H396.811V247.2Z",
    fill: "url(#paint5_linear_1_119)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 236.267H401.205V231.875H396.811V236.267Z",
    fill: "url(#paint6_linear_1_119)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 225.333H401.205V220.941H396.811V225.333Z",
    fill: "url(#paint7_linear_1_119)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 214.4H401.205V210.008H396.811V214.4Z",
    fill: "url(#paint8_linear_1_119)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M396.811 203.467H401.205V199.076H396.811V203.467Z",
    fill: "url(#paint9_linear_1_119)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M376.002 0H37.002L76.7583 33.9652H336.246L376.002 0Z",
    fill: "url(#paint10_linear_1_119)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00195 490.955H410.087L359.935 447H53.1547L3.00195 490.955Z",
    fill: "url(#paint11_linear_1_119)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73242 170.606V319.4L22.8305 301.07V188.938L6.73242 170.606Z",
    fill: "url(#paint12_linear_1_119)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 199.076H12V203.469H16.397V199.076Z",
    fill: "url(#paint13_linear_1_119)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 210.008H12V214.4H16.397V210.008Z",
    fill: "url(#paint14_linear_1_119)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 220.941H12V225.333H16.397V220.941Z",
    fill: "url(#paint15_linear_1_119)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 231.875H12V236.267H16.397V231.875Z",
    fill: "url(#paint16_linear_1_119)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 242.808H12V247.2H16.397V242.808Z",
    fill: "url(#paint17_linear_1_119)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 253.741H12V258.134H16.397V253.741Z",
    fill: "url(#paint18_linear_1_119)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 264.673H12V269.066H16.397V264.673Z",
    fill: "url(#paint19_linear_1_119)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 275.606H12V279.999H16.397V275.606Z",
    fill: "url(#paint20_linear_1_119)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 286.54H12V290.933H16.397V286.54Z",
    fill: "url(#paint21_linear_1_119)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_119",
    x1: 398.425,
    y1: 170.606,
    x2: 398.425,
    y2: 319.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_119",
    x1: 398.93,
    y1: 312.981,
    x2: 399.378,
    y2: 173.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_119",
    x1: 398.895,
    y1: 312.981,
    x2: 399.343,
    y2: 173.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_119",
    x1: 398.86,
    y1: 312.981,
    x2: 399.308,
    y2: 173.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_119",
    x1: 398.824,
    y1: 312.981,
    x2: 399.272,
    y2: 173.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_119",
    x1: 398.789,
    y1: 312.977,
    x2: 399.237,
    y2: 173.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_119",
    x1: 398.754,
    y1: 312.977,
    x2: 399.202,
    y2: 173.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_119",
    x1: 398.719,
    y1: 312.98,
    x2: 399.167,
    y2: 173.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_119",
    x1: 398.684,
    y1: 312.98,
    x2: 399.132,
    y2: 173.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_119",
    x1: 398.649,
    y1: 312.981,
    x2: 399.096,
    y2: 173.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_119",
    x1: 376.002,
    y1: 16.9857,
    x2: 37.002,
    y2: 16.9857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_119",
    x1: 410.087,
    y1: 468.981,
    x2: 3.00195,
    y2: 468.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_119",
    x1: 14.7814,
    y1: 170.606,
    x2: 14.7814,
    y2: 319.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_119",
    x1: 14.2755,
    y1: 177.027,
    x2: 13.8273,
    y2: 316.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_119",
    x1: 14.3105,
    y1: 177.027,
    x2: 13.8626,
    y2: 316.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_119",
    x1: 14.3457,
    y1: 177.029,
    x2: 13.8978,
    y2: 316.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_119",
    x1: 14.381,
    y1: 177.029,
    x2: 13.933,
    y2: 316.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_119",
    x1: 14.4162,
    y1: 177.027,
    x2: 13.9681,
    y2: 316.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_119",
    x1: 14.4513,
    y1: 177.026,
    x2: 14.0033,
    y2: 316.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_119",
    x1: 14.4865,
    y1: 177.027,
    x2: 14.0386,
    y2: 316.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_119",
    x1: 14.5218,
    y1: 177.027,
    x2: 14.0738,
    y2: 316.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_119",
    x1: 14.5568,
    y1: 177.027,
    x2: 14.1088,
    y2: 316.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00019045,
    stopColor: "#FF88C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerFrame);
export default __webpack_public_path__ + "static/media/SpeakerFrame.0e724e6e86320903edcc82179a3a33ea.svg";
export { ForwardRef as ReactComponent };